import store from '@/store'

const PERIPHERAL_TYPE = 'temperature'
const AUTO_CONNECT_TIMEOUT_MS = 10000

export default {
    data() {
        return {
            forceScan: false,
            BLEDeviceName: '',
            connectTimeoutId: null,
            connectAborted: false,
            isAutoConnecting: false,
            connectAttemptId: 0,
            pendingConnectAddress: null
        }
    },
    methods: {
        /**
         * @returns {{ id: string, name: string }|null}
         */
        getSavedTemperaturePeripheral() {
            return store.getters['userPreferences/getPeripheral'](PERIPHERAL_TYPE)
        },
        applySavedTemperaturePeripheral() {
            const device = this.getSavedTemperaturePeripheral()
            if (device && device.id) {
                this.BLEMAC = device.id
                this.BLEDeviceName = device.name || ''
                return device
            }
            this.BLEMAC = false
            this.BLEDeviceName = ''
            return null
        },
        saveTemperaturePeripheral(device) {
            if (!device || !device.id) {
                return
            }
            this.BLEDeviceName = device.name || this.BLEDeviceName || ''
            store.commit('userPreferences/setPeripheral', {
                type: PERIPHERAL_TYPE,
                device: {
                    id: device.id,
                    name: this.BLEDeviceName
                }
            })
        },
        persistCurrentTemperaturePeripheral() {
            if (!this.BLEMAC) {
                return
            }
            this.saveTemperaturePeripheral({
                id: this.BLEMAC,
                name: this.BLEDeviceName
            })
        },
        clearTemperatureConnectTimeout() {
            if (this.connectTimeoutId) {
                clearTimeout(this.connectTimeoutId)
                this.connectTimeoutId = null
            }
        },
        nextTemperatureConnectAttempt() {
            this.connectAttemptId += 1
            return this.connectAttemptId
        },
        isCurrentTemperatureConnectAttempt(attemptId) {
            return attemptId === this.connectAttemptId && !this.connectAborted
        },
        disconnectStaleTemperaturePeripheral(device) {
            const address = device && (device.id || device.address)
            if (typeof ble === 'undefined' || !address) {
                return
            }
            const liveAddress = this.pendingConnectAddress || this.BLEMAC
            if (!this.connectAborted && liveAddress && liveAddress === address) {
                return
            }
            ble.disconnect(
                address,
                function () {},
                function () {}
            )
        },
        cancelInFlightTemperatureConnect() {
            const address = this.pendingConnectAddress
            this.pendingConnectAddress = null
            if (typeof ble === 'undefined' || !address) {
                return
            }
            ble.disconnect(
                address,
                function () {},
                function () {}
            )
        },
        clearTemperatureConnectAttempt() {
            this.clearTemperatureConnectTimeout()
            this.connectAborted = true
            this.isAutoConnecting = false
            this.nextTemperatureConnectAttempt()
            this.cancelInFlightTemperatureConnect()
        },
        markTemperatureDeviceReady() {
            this.clearTemperatureConnectTimeout()
            this.isAutoConnecting = false
            this.pendingConnectAddress = null
        },
        beginManualTemperatureConnect() {
            this.connectAborted = false
            this.isAutoConnecting = false
            this.clearTemperatureConnectTimeout()
            this.nextTemperatureConnectAttempt()
        },
        handleTemperatureConnectSuccess(attemptId, device) {
            if (!this.isCurrentTemperatureConnectAttempt(attemptId)) {
                this.disconnectStaleTemperaturePeripheral(device)
                return false
            }
            this.pendingConnectAddress = null
            return true
        },
        handleTemperatureConnectFailure(attemptId) {
            if (!this.isCurrentTemperatureConnectAttempt(attemptId)) {
                return true
            }
            if (this.sensorStatus === 'waiting' || this.sensorStatus === 'finish') {
                this.clearTemperatureConnectTimeout()
                this.isAutoConnecting = false
                return true
            }
            if (this.isAutoConnecting) {
                this.clearTemperatureConnectTimeout()
                this.isAutoConnecting = false
                this.sensorStatus = 'error'
                return true
            }
            return false
        },
        startForcedTemperatureScan() {
            const self = this
            this.clearTemperatureConnectAttempt()
            this.forceScan = true
            this.stopScanBLE(() => {
                self.unsubscribeBLE(() => {
                    self.disconnectBLE(() => {
                        self.BLEMAC = false
                        self.launchBLESensor()
                    })
                })
            })
        },
        shouldAutoConnectSavedDevice() {
            return Boolean(this.BLEMAC) && !this.forceScan
        },
        connectToSavedTemperatureDevice() {
            const self = this
            this.connectAborted = false
            this.isAutoConnecting = true
            this.sensorStatus = 'connecting_2'
            this.searching = true
            this.clearTemperatureConnectTimeout()
            this.nextTemperatureConnectAttempt()
            this.connectTimeoutId = setTimeout(() => {
                self.connectTimeoutId = null
                if (self.connectAborted || self.sensorStatus === 'waiting' || self.sensorStatus === 'finish') {
                    return
                }
                self.clearTemperatureConnectAttempt()
                self.sensorStatus = 'error'
            }, AUTO_CONNECT_TIMEOUT_MS)
            this.connectBLE()
        }
    },
    beforeDestroy() {
        this.clearTemperatureConnectAttempt()
    }
}
